/**
 * HeldCell — the next-run cell of a row whose tracker's own switch holds the
 * scheduler (Tres Commas: off by default): "Held", the reason in the tooltip.
 * Split out of NextRunCell (one component per file).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { Tooltip } from '@/components/ui';

export interface HeldCellProps {
  /** Why the tracker holds its optimizer (the scheduler status' reason). */
  reason: string;
}

export const HeldCell: FC<HeldCellProps> = ({ reason }) => (
  <Tooltip content={reason}>
    <span className="font-medium text-warning">Held</span>
  </Tooltip>
);

export default HeldCell;
